export default __webpack_public_path__ + "static/media/avatar7.6340f4ac.svg";